import { OnInit, Component } from '@angular/core';
import { AuthenticationService, TokenPayload, TestData} from '../services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {MediaMatcher} from '@angular/cdk/layout';
import {ChangeDetectorRef} from '@angular/core';
import { AdminService } from '../services/admin.service';
import {MatCardModule} from '@angular/material/card';
import {MatGridListModule} from '@angular/material/grid-list';
import Swal from 'sweetalert2';
@Component({
  templateUrl: './createAdmin.component.html',
  styleUrls: [ './createAdmin.component.scss' ]
})
export class CreateAdminComponent implements OnInit {
  credentials: TokenPayload = {
    id: '',
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    // confirmpassword: '',
    phone: '',
    type: ''  
  };
  strongRegex = new RegExp(
   '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'
  );
  result: string[];
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  details: boolean;
  overall: boolean;
  questionset: boolean;
  scheduletest: boolean;
  evaluate: boolean;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };


  links = ['Super Admin', 'Admin', 'Test Scheduler', 'Test Taker'];
  registerForm: FormGroup;
  submitted = false;
  email;
  user;
  fname;
  lname;
  columns: string[];
  error: boolean;
  hostNameFromWeb: string;
  hostNameProtocol: string;
  actualHostName: string;
  userEvaluator: boolean;

    // tslint:disable-next-line: max-line-length
    constructor(private auth: AuthenticationService,  private route: ActivatedRoute, private adminservice: AdminService,
                private router: Router, private formBuilder: FormBuilder,
                changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
      this.getAccess();
      this.simpletest();
      this.mobileQuery = media.matchMedia('(max-width: 600px)');
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);
    }

    ngOnInit() {
      this.registerForm = this.formBuilder.group({
        first_name: ['', Validators.required],
        last_name: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        // password: ['', [Validators.required, Validators.minLength(5)]],
        phone: ['', [Validators.required, Validators.minLength(9) ]]
          // type: ['', Validators.required]
      });

      this.hostNameProtocol = window.location.protocol 
      this.hostNameFromWeb = window.location.host
      this.actualHostName = this.hostNameProtocol.concat("//",this.hostNameFromWeb)
      console.log("Printing the hostname ",this.actualHostName);
      this.getAccess();
    }

    getAccess(){
      this.user = sessionStorage.getItem('user');
      this.fname = sessionStorage.getItem('fname');

      this.lname = sessionStorage.getItem('lname');


      // if (this.user === '2') {

      //   this.userAdmin = true;
      //   this.userSuperAdmin = false;
      //   this.userTestScheduler = true;
      // } else if (this.user === '1') {

      //   this.userAdmin = true;
      //   this.userSuperAdmin = true;
      //   this.userTestScheduler = true;
      // } else if (this.user === '3') {
      //   this.userAdmin = false;
      //   this.userSuperAdmin = false;
      //   this.userTestScheduler = true;
      // }

      if (this.user === '1') {
        this.userAdmin = true;
        this.userTestScheduler = false;
        this.userEvaluator = false;
      } else if (this.user === '2') {
        this.userEvaluator = true;
        this.userAdmin = false;
        this.userTestScheduler = false;
      } else if (this.user === '3') {
        this.userTestScheduler = true;
        this.userAdmin = false;
        this.userEvaluator = false;  
      }
    }

    get f() { return this.registerForm.controls; }

  simpletest() {
    this.adminservice.admin(this.test).subscribe(
    (data) => {
     this.user = sessionStorage.getItem('user');
     this.fname = sessionStorage.getItem('fname');
     this.lname = sessionStorage.getItem('lname');
     this.result = data.results;
     return this.result;
    },
    err => {
      console.error(err);
    }

  );
}


  createAdmin() {
    console.log("inside createAdmin")
    this.submitted = true;

    if (this.registerForm.invalid) {
      console.log("inside invalid")
      //
      // this.submitted = false
      return;
    } else {
      console.log("inside valid")

      this.adminservice.createAdmin(this.credentials,this.actualHostName).subscribe(
              (data) => {
                // this.submitted = true;
                if (data.code === 200) {
                  
                  Swal.fire({
                    title: 'Success',
                    text: data.success,
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonText: 'OK'
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.router.navigateByUrl('/admin');
                    }
                  })
                  
                } else {
                  Swal.fire({
                    title: 'Alert',
                    text: data.failed,
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK'
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // this.router.navigateByUrl('/test_scheduler');
                    }
                  })
                }
              },
              err => {
                console.error(err);
              }
            );
      }

  }


    Oncancel() {
      this.router.navigateByUrl('/admin');
    }
 }
